module.exports = __webpack_public_path__ + "images/icons_v2/lock-filled-325cf9de.svg";